var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVolume = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n    .volume-st0{fill:#FFFFFF;}\n    .volume-st1{fill:none;stroke:#FFFFFF;stroke-width:16.4886;stroke-linecap:round;stroke-miterlimit:10;}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "sound"
  }, /*#__PURE__*/React.createElement("path", {
    className: "volume-st0",
    d: "M159,305.2h-5.2c-8.1,0-14.8-6.6-14.8-14.8v-69c0-8.1,6.6-14.8,14.8-14.8h5.2c8.1,0,14.8,6.6,14.8,14.8v69     C173.8,298.6,167.2,305.2,159,305.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "volume-st0",
    d: "M241.8,336.7l-47.7-28.5c-3.1-1.9-5-5-5-8.3v-87.8c0-3.3,1.9-6.4,5-8.3l47.7-28.5c7.6-4.5,17.9,0.2,17.9,8.3     v144.8C259.6,336.4,249.4,341.2,241.8,336.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "threeLines"
  }, /*#__PURE__*/React.createElement("path", {
    id: "low",
    className: "volume-st1",
    d: "M290.1,241.3c5.1,2.9,8.5,8.4,8.5,14.7s-3.4,11.8-8.5,14.7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "medium",
    className: "volume-st1",
    d: "M290.1,201.4c25.5,5.1,44.8,27.6,44.8,54.6s-19.3,49.5-44.8,54.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "high",
    className: "volume-st1",
    d: "M290.1,162.3c46.7,5.7,82.9,45.5,82.9,93.7s-36.2,88-82.9,93.7"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVolume, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/volume.0cb7afae.svg";
export { ForwardRef as ReactComponent };